export default __webpack_public_path__ + "static/media/settings.a236b9e6.svg";